const ACCESS_TOKEN = 'ACCESS_TOKEN';
const USER_TYPE = 'USER_TYPE'; 
const DATE_LOGIN = 'DATE_LOGIN';
const ACCESS_CODE = 'ACCESS_CODE' 

export default {
    getUserType() {
      return localStorage.getItem(USER_TYPE);
    },
    getAccessToken() {
      return localStorage.getItem(ACCESS_TOKEN);
    },
    getAccessCode(){
      return localStorage.getItem(ACCESS_CODE);
    },
    setTokens(access, role) {
        localStorage.setItem(ACCESS_TOKEN, access);
        localStorage.removeItem('is_sh_pr')
        localStorage.setItem(USER_TYPE, role);
        // localStorage.setItem(DATE_LOGIN, moment(new Date()).format());
    },
    removeAccessToken() {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem('is_sh_pr')
      },
      removeDateLogin() {
        localStorage.removeItem(DATE_LOGIN);
      },
      async resetLoginStore() {
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(DATE_LOGIN);
        localStorage.removeItem(USER_TYPE);
        localStorage.removeItem('persist:lsd');
        localStorage.removeItem('is_sh_pr')
    },
    get isAuthenticated() {
        try {
          return !!this.getAccessToken();
        } catch (e) {
          return false;
        }
      },    
}  